/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Trans } from 'react-i18next';
import { Grid, makeStyles, Divider } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { Info } from '@material-ui/icons';
import { draftActions } from '../../draft/draftReducer';
import RadioWidget from './RadioWidget';
import Tooltip from '../../common/Tooltip';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';

const useStyles = makeStyles(theme => ({
  section: {
    visibility: 'visible',
    opacity: 1,
    transition: 'visibility 0s, opacity 0.5s linear',
  },
  sectionHidden: {
    visibility: 'hidden',
    opacity: 0,
    height: 0,
    transition: 'visibility 0s, opacity 0.5s linear',
  },
  sectionInfo: {
    backgroundColor: 'transparent',
    borderRadius: '0.2rem',
    padding: '1rem 0.2rem',
  },
  sectionInfoDisplay: {
    display: 'flex',
    marginBottom: '2rem',
    marginTop: '2rem',
  },
  infoIcon: {
    color: theme.palette.info.main,
    marginRight: '0.5rem',
  },
  infoText: {
    marginBottom: 0,
    color: theme.palette.mainText,
  },
}));

export default function FeesRadio(props) {
  const _onBlur = (feeValue) => {
    props.onBlur(feeValue);
    if (typeof props.formContext.dispatchDraftState === 'function') {
      props.formContext.dispatchDraftState({ type: draftActions.CALCULATE_WORKFLOW_POSTPROCESS_START });
    }
  };

  const { options, value, uiSchema = {}, id } = props;
  const tooltip = uiSchema[uiSchemaProperties.UI_TOOLTIP];
  const isSectionHidden = uiSchema['ui:hidden'] && (id.startsWith('submission') || id.startsWith('paymentSection'));
  const info = uiSchema['ui:info'];
  const sectionTitle = uiSchema['ui:sectionTitle'];
  const classes = useStyles();

  return (
    <div className={classNames(classes.section, isSectionHidden && classes.sectionHidden)}>
      {sectionTitle && (
        <>
          <Typography aria-label={sectionTitle} variant="h3">
            <strong>{sectionTitle}</strong>
          </Typography>

          <Divider />
        </>
      )}
      {info && (
        <div className={classes.sectionInfoDisplay}>
          <Info className={classes.infoIcon} />
          <Typography className={classes.infoText} variant="body1" data-testid="info-text">
            <Trans i18nKey={info} />
          </Typography>
        </div>
      )}
      <Grid container direction="row" alignItems="center">
        <Typography aria-label={props.uiSchema['ui:title']} variant="h5">
          <strong>{props.uiSchema['ui:title']}</strong>
        </Typography>
        {tooltip && <Tooltip title={<Trans i18nKey={tooltip} />} />}
      </Grid>
      <RadioWidget {...props} onBlur={_onBlur} value={options?.deselect === value ? null : value} hideTitle={true} />
    </div>
  );
}
